import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { ValidateZipCodeResponse } from '@models/swagger';
import { ValidateZipCodeFailure, ValidateZipCodeRequest, ValidateZipCodeSuccess } from './actions';

export const featureKey = 'validateZipCode';

export interface State {
  data: ValidateZipCodeResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(ValidateZipCodeFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(ValidateZipCodeRequest, state => ({ ...state, error: null, loading: true })),
    on(ValidateZipCodeSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
